import styled from 'styled-components';

export const TextoPopover = styled.h5`
  @media only screen and (min-device-width: 640px) {
    max-width: 300px !important;
  }
`;
